import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Thead, Tr } from 'next/components/ui';
import TableOverlay from 'components/Insights/Explorer/Common/TableOverlay';
import {
  ControlHeader,
  EventNameHeader,
  ResultsWrapper,
  StatsHeader,
  StatusHeader,
  TableWrapper,
} from 'components/Insights/Common/Styled';
import { PIN_EVENTS_LABEL } from 'components/Insights/constants';
import { TitleTooltip } from 'components/Insights/Explorer/Common/SourceTooltips';

export const PinEvents = ({ results }) => {
  return (
    <ResultsWrapper>
      <TableOverlay isEmpty results={results} type={PIN_EVENTS_LABEL} />
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <ControlHeader />
              <EventNameHeader sortable>Pin Name</EventNameHeader>
              <StatusHeader sortable>Status</StatusHeader>
              <StatsHeader sortable>
                <TitleTooltip
                  tip="The number of total event ocurrences."
                  title="Total Events"
                />
              </StatsHeader>
              <StatsHeader sortable>
                <TitleTooltip
                  tip="The number of unique users who triggered the event."
                  title="Unique Users"
                />
              </StatsHeader>
              <StatsHeader sortable>Last Triggered</StatsHeader>
            </Tr>
          </Thead>
        </Table>
      </TableWrapper>
    </ResultsWrapper>
  );
};

PinEvents.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({})),
  pageSize: PropTypes.number,
  selectedEvents: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string,
      event: PropTypes.string,
    })
  ),
  onClearEvents: PropTypes.func,
};

export const mapStateToProps = () => {
  return { results: [] };
};

export default connect(mapStateToProps)(PinEvents);
